export interface IControlPanelModel extends IModelBase {
    GrantCodeSelected: string;
    RoleCodeSelected: string;
}

export class ControlPanelModel implements IControlPanelModel {
    GrantCodeSelected: string;
    RoleCodeSelected: string;
}